import React, { useRef, useEffect } from 'react';
import SimpleTable, { ButtonsExportar } from '../../../../core/components/simpleTables/SimpleTable';
import tableStyles from './Tables.module.scss';
import historicoVersoesIndicadorService from '../../../../service/HistoricoVersoesIndicadorService';
import { inputsHistoricoVersoes } from '../PageInputs';
import { Column } from 'primereact/column';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import LinkTo from '../../../../core/components/LinkTo';
import Pages from '../../../../config/Pages';
import { useHistory, useParams } from 'react-router-dom';

function HistoricoVersoes() {
    const tableRef = useRef(null);
    const history = useHistory();
    const { id } = useParams();

    useEffect(() => {
        tableRef.current?.onFiltro({ indicador: { id } });
    }, []);

    return (
        <div>
            <SimpleTable
                ref={tableRef}
                onFind={historicoVersoesIndicadorService.pesquisar.bind(
                    historicoVersoesIndicadorService
                )}
                header={
                    <div className={tableStyles.containerExportButtons}>
                        <ButtonsExportar
                            onExportar={(tipo) =>
                                historicoVersoesIndicadorService.exportaDataToFile(tipo, {
                                    search: `indicador.id==${id}`,
                                })
                            }
                        />
                    </div>
                }
            >
                {inputsHistoricoVersoes
                    .filter((input) => input?.table?.use ?? false)
                    .map((el, index) => (
                        <Column key={index} field={el?.name} header={el?.label} />
                    ))}
                <Column
                    header="Ações"
                    body={({ proposta }) => (
                        <div className={tableStyles.actionButtons}>
                            <ButtonSeplag
                                tipo="info"
                                type="button"
                                tooltip="Visualizar"
                                tooltipOptions={{ position: 'top' }}
                                icon="pi pi-eye"
                                onClick={() => {
                                    history.push(
                                        Pages.sei.historicoIndicador.url.view
                                            .replace(':id', id)
                                            .replace(':idProposta', proposta?.id)
                                    );
                                }}
                            />
                            <LinkTo
                                to={Pages.sei.statusProposta.url.list.replace(':id', proposta.id)}
                            >
                                <ButtonSeplag
                                    tipo="help"
                                    type="button"
                                    tooltip="Status da Proposta"
                                    tooltipOptions={{ position: 'top' }}
                                    icon="pi pi-arrow-right-arrow-left"
                                    style={{ marginLeft: '.5em' }}
                                />
                            </LinkTo>
                        </div>
                    )}
                />
            </SimpleTable>
        </div>
    );
}

export default HistoricoVersoes;
